<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('approvalRequest.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('approvalRequest.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <a-tabs default-active-key="1">
          <a-tab-pane key="1">
            <span slot="tab">
             <a-icon type="folder" />
              {{ $t('approvalRequest.pending') }} 
            </span>
						<PenddingList />
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab">
              <a-icon type="history" />
              {{ $t('approvalRequest.history') }} 
            </span>
            <HistoryTap />
          </a-tab-pane>
        </a-tabs>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import PenddingList from './components/pendding-list.vue'
import HistoryTap from './components/history-tap.vue'
export default {
	name: 'approvalRequest',
	components: {
		PenddingList,
		HistoryTap
	},
	data() {
		return {
			
		}
	},
}
</script>
